// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1v0yI","headerPrivateContent":"Header_headerPrivateContent__1I5cm","fixedHeader":"Header_fixedHeader__3s4Dt"};